import { render, staticRenderFns } from "./ProjectPropertyPopup.vue?vue&type=template&id=6227b39c&"
import script from "./ProjectPropertyPopup.vue?vue&type=script&lang=js&"
export * from "./ProjectPropertyPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports